import { useState } from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import useMediaQuery from "../hooks/useMediaQuery";
// import MenuIcon from "../assets/menu_hamburger-white.svg";
// import CloseIcon from "../assets/close-icon.svg";
import { motion } from "framer-motion";
// import Logo from "../assets/strange-lot-logo-white-01.png";
// import Background from "../assets/dark-grain.png";

// ... (imports and other code)

const Link = ({ page, selectedPage, setSelectedPage, isTopOfPage }) => {
  const lowerCasePage = page.toLowerCase();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <AnchorLink
      className={`${selectedPage === lowerCasePage ? "text-rust" : ""} transition-colors duration-500 ${isHovered ? "text-rust" : "text-coolPaper"}`}
      href={`#${lowerCasePage}`}
      onClick={() => setSelectedPage(lowerCasePage)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {page}
    </AnchorLink>
  );
};

const Navbar = ({ isTopOfPage, selectedPage, setSelectedPage }) => {
  const isAboveSmallScreens = useMediaQuery("(min-width: 768px)");
  // const navbarBackground = isTopOfPage ? "bg-black" : "bg-gold";
  const navbarText = isAboveSmallScreens ? "py-1 text-lg" : "py-1 text-xl mt-1";

  return (
    <nav className="z-40 w-full top-0 bg-coolDark pb-6 md:pb-8">
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className={`flex ${navbarText} items-center gap-6 md:gap-20 font-integralCF text-coolPaper max-w-6xl mx-auto px-6 md:px-10`}
      >
        <Link
          page="STORE"
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          isTopOfPage={isTopOfPage}
        />
        <Link
          page="VIDEO"
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          isTopOfPage={isTopOfPage}
        />
        <Link
          page="LIVE"
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          isTopOfPage={isTopOfPage}
        />
        <Link
          page="CONTACT"
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          isTopOfPage={isTopOfPage}
        />
      </motion.div>
    </nav>
  );
};

export default Navbar;
